import React, { useEffect, useState } from 'react'

import { Button, Input, Textarea } from 'shared/components'

import classes from './PartnerForm.module.scss'

export const PartnerForm = (): JSX.Element => {
  const initialform = {
    name: '',
    email: '',
    phone: '',
    company: '',
    descr: '',
  }

  const [form, setForm] = useState(initialform)
  const [errors, setErrors] = useState(Object.assign({}, initialform))
  const [isValid, setIsValid] = useState(false)

  const emailReg = /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i
  const phoneReg =
    /((\+7)-?)?\(?\d{3}\)?-?\d{1}-?\d{1}-?\d{1}-?\d{1}-?\d{1}-?\d{1}-?\d{1}/

  function getFieldsError(
    fieldName: string,
    value: string,
    maxSize?: number,
    format?: RegExp
  ) {
    let error = ''
    if (!value) {
      error = `Введите значение`
    }
    if (maxSize && value.length > maxSize) {
      error = `Макс. длина: ${maxSize} символов`
    }
    if (format && !format.test(value)) {
      error = 'Неверный формат'
    }
    setErrors({ ...errors, [fieldName]: error })
  }
  function changeForm(
    fieldName: string,
    value: string,
    maxSize?: number,
    format?: RegExp
  ) {
    setForm({ ...form, [fieldName]: value })
    getFieldsError(fieldName, value, maxSize, format)
  }

  useEffect(() => {
    setIsValid(
      Object.values(errors).some(v => !v) && !Object.values(form).some(v => !v)
    )
  }, [errors, form])

  return (
    <form className={classes.form}>
      <legend>Заявка на партнерство</legend>
      <p className={classes.descr}>
        Расскажите о себе, и мы свяжемся с вами в ближайшее время для уточнения
        деталей сотрудничества
      </p>
      <div className="form-group--small">
        <Input
          placeholder="ФИО"
          maxLength={50}
          type="text"
          required={true}
          value={form.name}
          onInput={e => {
            changeForm('name', e.currentTarget.value, 50)
          }}
        />
        <small className={classes.error}>{errors.name}</small>
      </div>
      <div className="form-group--small">
        <Input
          placeholder="Email"
          maxLength={50}
          type="text"
          required={true}
          value={form.email}
          onInput={e => {
            changeForm('email', e.currentTarget.value, 50, emailReg)
          }}
        />
        <small className={classes.error}>{errors.email}</small>
      </div>
      <div className="form-group--small">
        <Input
          placeholder="Телефон"
          maxLength={50}
          type="text"
          required={true}
          value={form.phone}
          onInput={e => {
            changeForm('phone', e.currentTarget.value, 50, phoneReg)
          }}
        />
        <small className={classes.error}>{errors.phone}</small>
      </div>
      <div className="form-group--small">
        <Input
          placeholder="Компания"
          maxLength={50}
          type="text"
          required={true}
          value={form.company}
          onInput={e => {
            changeForm('company', e.currentTarget.value, 50)
          }}
        />
        <small className={classes.error}>{errors.company}</small>
      </div>
      <div className="form-group--small">
        <Textarea
          required={true}
          maxLength={1000}
          placeholder="Опишите кратко, как планируете привлекать подписчиков"
          value={form.descr}
          counter={true}
          resize={true}
          cb={value => changeForm('descr', value, 1000)}
        />
      </div>
      <small className={classes.required}>обязательное поле</small>
      <div className={classes.form__footer}>
        <Button className={classes.btn} disabled={!isValid}>
          Отправить
        </Button>
        <div className={classes.text}>
          Нажимая на кнопку “Отправить”, вы принимаете{' '}
          <a href="/">условия пользовательского соглашения</a>
        </div>
      </div>
    </form>
  )
}
